import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../PatientReview.js';
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import Counter from '../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Best ENT Surgery in Delhi | Expert Care at MedFirst ENT</title>
            <meta name="description" content="TGet expert ENT surgery in Delhi with advanced care for sinus, ear, throat, and voice disorders. Book a consultation with top ENT surgeons at ENT Delhi today." />
            <meta name="keywords" content="ENT surgery in Delhi,Affordable ENT surgery Delhi,Top cholesteatoma surgeons in Delhi,Best ENT surgeon for cholesteatoma in Delhi,Endoscopic surgery for cholesteatoma in delhi,Cochlear implant surgery cost in delhi,Low-cost ENT surgeries,Cashless ENT surgery Delhi,Affordable ENT Surgery Delhi" />
            <link rel="canonical" href="https://entdelhi.com/ent-surgery/" />
            <meta property="og:title" content="Open Graph Title" />
            <meta property="og:description" content="Open Graph Description for Facebook etc." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         <GetInTouch/>
      </main>
    </div>
  )
}
